export interface Dashboard {
    dashboardSignal: any | null;
    loadingSignal: boolean;
  }
  
  export const initialState: Dashboard = {
    dashboardSignal: null,
    loadingSignal: false,
  };